import { render, staticRenderFns } from "./BasePlaceOrderButton.vue?vue&type=template&id=3d833ccc&scoped=true"
import script from "./BasePlaceOrderButton.vue?vue&type=script&lang=js"
export * from "./BasePlaceOrderButton.vue?vue&type=script&lang=js"
import style0 from "./BasePlaceOrderButton.vue?vue&type=style&index=0&id=3d833ccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d833ccc",
  null
  
)

export default component.exports